import React, { useState } from "react";
import { Header } from "../../components/Header";
import { useEffect } from "react";
import { BASE_URL_API } from "../../components/Constants";
import axios from "axios";
import { Autocomplete } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { TextField, MenuItem } from "@mui/material";
import { useUser } from "../../ContextApi/UserContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { CLIENT_SECRET, CLIENT_ID } from "../../components/Constants";
import Toastify from 'toastify-js';
import crypto from 'crypto-js';
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { getInitials } from "../../components/Helper";
import { useNavigate } from "react-router-dom";
import { BASE_URL_OPENFORGE } from "../../components/Constants";
import { useLocation } from "react-router-dom";
import { DATA_DECRYPTION_KEY } from "../../components/Constants";
import { decryptAES } from "../../components/CryptoUtils";
import { encryptAES } from "../../components/CryptoUtils";
import DOMPurify from 'dompurify';
import { IMAGE_PATH_Leader } from "../../components/Constants";
import { DEFAULT_USER_IMAGE } from "../../components/Constants";


library.add(faEdit);

export default function UserProfileEdit() {
    const { user, isLoggedIn, isLoading: userLoading } = useUser();
    // const userLoading = false;
    // const isLoggedIn = true;
    // const user = { id: 71983, realname: "sushant", username: "sushantshekhar", email: "sushantpu@example.com", joined_on: "1736752822" };

    const navigate = useNavigate();
    const location = useLocation();


    const [formData, setFormData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [preview, setPreview] = useState(null);
    const [profileUrl, setProfileUrl] = useState(null);



    const [masterData, setMasterData] = useState({
        qualifications: [],
        employement_type: [],
        programming_languages: [],
        frameworks: [],
        state: [],
        roles: [],
        ministry_list: [],
        departments_list: [],
        designations_list: [],
        institute_name: [],
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (!isLoggedIn || !user) return;

            // Fields you want to sanitize & validate
            const fieldsToValidate = ["about_me", "employee_id", "govt_association"];

            for (const field of fieldsToValidate) {
            const original = formData[field] || "";
            const clean = DOMPurify.sanitize(original, {
                ALLOWED_TAGS: [],
                ALLOWED_ATTR: [],
            });
            if (clean !== original) {
                Toastify({
                text: `Invalid input: no tags allowed in ${field.replace("_", " ")}.`,
                duration: 3000,
                close: true,
                gravity: "top",
                position: "right",
                backgroundColor: "#f00",
                stopOnFocus: true,
                }).showToast();
                return;
            }
            }

            setIsLoading(true);

            const ts = Math.floor(Date.now() / 1000);
            const hmacStr = CLIENT_SECRET + CLIENT_ID + user.id.toString() + user.email.toString() + ts.toString();
            const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);
            const fd = new FormData();
            fd.append("user_id", user.id);
            fd.append("user_email", user.email)
            fd.append("client_id", CLIENT_ID);
            fd.append("ts", ts);
            fd.append("hmac", hmacHash);
            fd.append("user_name", user.username)

            Object.keys(formData).forEach((key) => {
                const value = formData[key];

                if (value === undefined || value === null ) return;

                if (value === 0) return;

                if (Array.isArray(value)) {
                    if (value.length === 0) {
                        fd.append(key, "");
                    } else {
                        fd.append(key, value.join(","));
                    }
                    return;
                }
                if (key === "profile_image" && value instanceof File) {
                    fd.append("profile_image", value);
                } else {
                    fd.append(key, value);
                }
            });
            const jsonObject = {};
            fd.forEach((value, key) => {
            if (value instanceof File) return;  // avoid breaking JSON
            jsonObject[key] = value;
            });

            const jsonString = JSON.stringify(jsonObject);

            const encrypted = await encryptAES(jsonString, DATA_DECRYPTION_KEY);

            const secureFD = new FormData();
            secureFD.append("user_data", encrypted);
            fd.forEach((value, key) => {
                if (value instanceof File) 
                    secureFD.append("profile_image", formData.profile_image)
            });

            const result = await axios.post(`${BASE_URL_API}user/save_additional_profile`, secureFD);

            if (result.data.code === 200) {

                Toastify({
                    text: "Profile Updated successfully.",
                    duration: 3000,
                    close: true,
                    gravity: "top",
                    position: "right",
                    backgroundColor: "#198754",
                    stopOnFocus: true,
                }).showToast();
            }
            else {
                Toastify({
                    text: "Something went wrong. Please try again.",
                    duration: 3000,
                    close: true,
                    gravity: "top",
                    position: "right",
                    backgroundColor: "#f00",
                    stopOnFocus: true,
                }).showToast();
            }
        } catch (error) {
            Toastify({
                text: "Something went wrong. Please try again.",
                duration: 3000,
                close: true,
                gravity: "top",
                position: "right",
                backgroundColor: "#f00",
                stopOnFocus: true,
            }).showToast();
            console.error("There was a problem fetching the tasks:", error);
        }
        finally {
            setIsLoading(false)
        }
    };

    const getUniversityList = async () => {
        try {
            const res = await axios.post(`${BASE_URL_API}get_university_cls_list`);
            setMasterData((prev) => ({
                ...prev,
                institute_name: res.data.data.records,
            }));
        } catch (err) {
            console.error("Error fetching university list:", err);
        }
    };

    const fetchMasterData = async (key) => {
        try {

            const formData = new FormData();
            formData.append("key", key);
            const response = await axios.post(`${BASE_URL_API}get_master_data`, formData, {});

            setMasterData((prev) => ({
                ...prev,
                [key]: response.data.data,
            }));

        } catch (error) {
            console.error(`Error fetching ${key} data:`, error.response?.data || error);
        }

    };




 
    const fetchState = async (key) => {
        try {

            const response = await axios.post(`${BASE_URL_API}get_state_list`, {});
            setMasterData((prev) => ({
                ...prev,
                [key]: response.data.data,
            }));

        } catch (error) {
            console.error(`Error fetching ${key} data:`, error.response?.data || error);
        }
    };

    const fetchUserProfileData = async () => {
        try {
            const fd = new FormData();
            fd.append("user_id", user.id);
            const ts = Math.floor(Date.now() / 1000);
            const hmacStr = CLIENT_SECRET + CLIENT_ID + user.id.toString() + ts.toString();
            const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);
            fd.append("client_id", CLIENT_ID);
            fd.append("ts", ts);
            fd.append("hmac", hmacHash);
            const jsonObject = {};
            fd.forEach((value, key) => {
                jsonObject[key] = value;
            });
                        
            const jsonString = JSON.stringify(jsonObject);
                        
            const encrypted = await encryptAES(jsonString, DATA_DECRYPTION_KEY);

            const secureFD = new FormData();
            secureFD.append("request_data", encrypted);     

            const response = await axios.post(
                `${BASE_URL_API}get_user_additional_profile`,
                secureFD
            );
            const decryptedText = await decryptAES(
                response.data.data,
                DATA_DECRYPTION_KEY
            );


            const profileArray = await JSON.parse(decryptedText);
            const profile =
                Array.isArray(profileArray) && profileArray.length > 0
                    ? profileArray[0]
                    : {};

            let imageUrl = "";

            if (profile?.profile_image) {
                imageUrl = `${IMAGE_PATH_Leader}/profile_images/${profile.profile_image.split("/").pop()}`;
                setProfileUrl(imageUrl);

            }
            else{
                setProfileUrl(DEFAULT_USER_IMAGE)
            }
        
            const { user_id, profile_image, profile_image_data, user_name, skills: fetchedSkills, ...rest } = profile;


            const normalizedEmployment =
                profile.employment_type
                    ? profile.employment_type.charAt(0).toUpperCase() +
                    profile.employment_type.slice(1).toLowerCase()
                    : "";


            // Extract language and framework arrays safely
            const languageIds = Array.isArray(profile.skills?.language)
                ? profile.skills.language.map((s) => Number(s.lang_id))
                : [];

            const frameworkIds = Array.isArray(profile.skills?.framework)
                ? profile.skills.framework.map((s) => Number(s.lang_id))
                : [];

            const updatedForm = {
                ...rest,
                current_role: profile.current_role_position || "",


                employment_type: normalizedEmployment || "",
                associated_ministry: profile.associated_ministry || "",
                language_ids: languageIds,
                framework_ids: frameworkIds,
            };
            setFormData(updatedForm);
        } catch (error) {
            console.error("Error fetching user profile:", error);
        }
    };


    const handleEmploymentTypeChange = (e) => {
        const value = e.name;
        setFormData(prev => {
            if (value === "Government") {
                return {
                    ...prev,
                    employment_type: value,
                    associated_ministry:"" ,
                    govt_association: "",
                    payroll_company_nature: "",
                };
            } else if (value === "Private") {
                return {
                    ...prev,
                    employment_type: value,
                    associated_ministry: "",
                    govt_association: "",
                    payroll_company_nature: "",
                };
            }
            return { ...prev, employment_type: value };
        });
    };

    const handleOrganizationChange = (e) => {
        const value = e.value;

        setFormData((prev) => ({
            ...prev,
            organization_department_name: value,
            other_organization_department_name: Number(value) === Number(5000) ? prev.other_organization_department_name : "",
        }));
    };


    useEffect(() => {
        if (!user) return;

        const fetchAllMasterData = async () => {
            setIsLoading(true);
            try {
                await Promise.all([
                    fetchMasterData("qualifications"),
                    fetchMasterData("programming_languages"),
                    fetchMasterData("frameworks"),
                    fetchMasterData("employement_type"),
                    fetchMasterData("roles"),
                    fetchMasterData("ministry_list"),
                    fetchMasterData("departments_list"),
                    fetchMasterData("designations_list"),
                    fetchState("state"),
                    fetchUserProfileData(),
                    getUniversityList()
                ]);
            } finally {
                setIsLoading(false);
            }
        };
        fetchAllMasterData();
    }, [user?.id]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            setFormData((prev) => ({
                ...prev,
                profile_image: file,
            }));
            setPreview(URL.createObjectURL(file));
        }
    };

        const formatDate = (input) => {
        if (!input) return "-";

        let date;

        if (typeof input === "number" || /^\d+$/.test(input)) {
        const ts = Number(input);
        date = new Date(ts < 1e12 ? ts * 1000 : ts);
        } else {
        date = new Date(input.replace(",", ""));
        }

        if (isNaN(date.getTime())) return "-";

        return date
        .toLocaleDateString("en-US", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        };



    // EARLY RETURN if not logged in
    //   if (!isLoggedIn || !user) {
    //     return (
    //       <>
    //         <Header />
    //         <div style={{ marginTop: 50, textAlign: 'center', color: '#555' }}>
    //           Please log in to view your profile.
    //         </div>
    //       </>
    //     );
    //   }
    // useEffect(() => {
    //   if (userLoading) return;              // Wait for PHP session check to finish

    //   if (!isLoggedIn) {                // User NOT logged in → redirect once
    //     const redirectUrl = location?.pathname || "/";
    //     localStorage.setItem("redirectUrl", redirectUrl);

    //     window.location.href =
    //       `${BASE_URL_OPENFORGE}/account/login.php?requested_by=collabwithgov`;
    //   }
    // }, [ userLoading, isLoggedIn]);

    // // ---- RETURN LOGIC ----

    // if (userLoading) return null;           // Still verifying login
    // if (!isLoggedIn) return null;       // Redirect already triggered

    // // User is logged in, but user data hasn't loaded yet
    // if (!user) return null;             // Prevents "realname undefined" crash



    const handleLogin = () => {
        const redirectUrl = location?.pathname ? location.pathname : null;

        if (redirectUrl) {
            localStorage.setItem("redirectUrl", redirectUrl);
        }

        //const redirectUrlGet = localStorage.getItem("redirectUrl");
        //const url = ${BASE_URL_OPENFORGE}${redirectUrlGet};

        window.location.href = `${BASE_URL_OPENFORGE}/account/login.php?requested_by=collabwithgov`;
    };

    // EARLY RETURN if not logged in
    if (!isLoggedIn || !user) {
        return (
            <>
                <Header />
                <div style={{ marginTop: 100, textAlign: 'center', color: '#555', height: '50vh' }}>
                    Please <span onClick={handleLogin} style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>log in</span> to view your profile.
                </div>
            </>
        );
    }






    return (
        <main>
            <Header />
            <div className="split-background">
                <style>{`
                .split-background {
                    min-height: 100vh;
                    width: 100%;
                    background: linear-gradient(
                    to bottom,
                    #00675b 0,
                    #00675b 30%,
                    #ffffff 30%,
                    #ffffff 100%
                    );
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: flex-start;
                    padding-top: 100px;
                    padding-bottom: 50px;
                }

                form {
                    width: 950px;
                    max-width: 95%;
                    margin: 0 auto;
                }

                .card {
                    border-radius: 12px !important;
                    background: #fff;
                }

                .profile-circle {
                    width: 120px;
                    height: 120px;
                    border-radius: 50%;
                    background-color:  rgba(170, 246, 237, 1);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 28px;
                    font-weight: bold;
                    color: rgba(0, 103, 91, 1);
                }

                .name {
                    font-family: Roboto, sans-serif;
                    font-weight: 600;
                    font-size: 32px;
                    color: rgba(0, 103, 91, 1);
                    line-height: 40px;
                }

                .form-label {
                    font-weight: 500;
                    color: #555;
                }

                .heading,
                .about-me-heading {
                    font-size: 22px;
                    font-weight: 600;
                    margin-bottom: 10px;
                    color: rgba(0, 103, 91, 1);
                }

                .update-button {
                    font-family: Roboto, sans-serif;
                    font-weight: 600;
                    font-size: 14px;
                    padding: 10px 20px;
                    border-radius: 10px;
                    border: none;
                    background-color: rgba(0, 103, 91, 1);
                    color: white;
                    cursor: pointer;
                    height: 80px;
                    display: block;
                    transition: background-color 0.3s ease;
                    margin: 40px auto 20px;
                    max-width: 980px;
                    width: 100%;
                }

                .update-button:hover {
                    background-color: #005f52;
                }

                .section-wrapper {
                    margin-bottom: 2rem; /* spacing between sections */
                }

                .section-wrapper .heading {
                    font-size: 22px;
                    font-weight: 600;
                    margin-bottom: 12px; /* spacing between heading and box */
                    color: rgba(0, 103, 91, 1);
                    text-align: left;
                    padding-left: 12px; /* aligns heading with box content */
                }
  
                /* Medium screens (tablets) */
                @media (max-width: 992px) {
                    form {
                    width: 90%;
                    }

                    .name {
                    font-size: 26px;
                    }

                    .profile-circle {
                    width: 100px;
                    height: 100px;
                    font-size: 24px;
                    }

                    .heading,
                    .about-me-heading {
                    font-size: 20px;
                    }
                }

                /* Small screens (mobiles) */
                @media (max-width: 768px) {
                    .split-background {
                    padding-top: 100px;
                    }

                    .card {
                    padding: 1rem !important;
                    }

                    .row {
                    flex-direction: column;
                    }

                    .col-md-4,
                    .col-md-9 {
                    width: 100% !important;
                    }

                    .profile-circle {
                    width: 90px;
                    height: 90px;
                    font-size: 22px;
                    }

                    .name {
                    font-size: 22px;
                    line-height: 32px;
                    }

                    .update-button {
                    width: 100%;
                    height: 50px;
                    font-size: 13px;
                    }
                }

                /* Extra small screens */
                @media (max-width: 576px) {
                    .split-background {
                    padding-top: 100px;
                    }

                    .name {
                    font-size: 20px;
                    text-align: center;
                    }

                    .heading,
                    .about-me-heading {
                    font-size: 18px;
                    text-align: left;
                    }

                    .profile-circle {
                    width: 80px;
                    height: 80px;
                    font-size: 20px;
                    }

                    .update-button {
                    width: 100%;
                    font-size: 12px;
                    height: 45px;
                    }
                }      
        `}</style>
                {
                    (isLoading)
                        ?
                        <SkeletonTheme baseColor="#ebebeb" highlightColor="#fff">
                            <div
                                style={{
                                    width: "100%",
                                    minHeight: "calc(100vh - 150px)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <div
                                    style={{
                                        width: "950px",
                                        maxWidth: "95%",
                                        background: "#fff",
                                        borderRadius: 16,
                                        padding: "16px 8px",
                                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                    }}
                                >
                                    <div className="d-flex justify-content-end mb-3">
                                        <Skeleton width={80} height={28} />
                                    </div>
                                    <div className="d-flex align-items-center mb-4">
                                        <Skeleton circle width={120} height={120} />
                                        <div style={{ marginLeft: 16, flex: 1 }}>
                                            <Skeleton height={28} width="60%" style={{ marginBottom: 10 }} />
                                            <Skeleton height={20} width="40%" style={{ marginBottom: 6 }} />
                                            <Skeleton height={20} width="50%" />
                                        </div>
                                    </div>
                                    <Skeleton height={25} width="30%" style={{ marginBottom: 10 }} />
                                    <Skeleton count={3} />
                                    <Skeleton height={25} width="40%" style={{ marginTop: 20, marginBottom: 10 }} />
                                    <Skeleton count={2} />
                                    <Skeleton height={25} width="50%" style={{ marginTop: 20, marginBottom: 10 }} />
                                    <Skeleton count={3} height={40} style={{ marginBottom: 8 }} />
                                    <Skeleton height={25} width="50%" style={{ marginTop: 20, marginBottom: 10 }} />
                                    <div className="d-flex gap-2">
                                        <Skeleton width={100} height={100} />
                                        <Skeleton width={100} height={100} />
                                        <Skeleton width={100} height={100} />
                                    </div>
                                </div>
                            </div>
                        </SkeletonTheme>
                        :
                        (<LocalizationProvider dateAdapter={AdapterDayjs}>
                            <form onSubmit={handleSubmit}>
                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: 16,
                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                        margin: "0 auto",
                                        padding: "16px 8px",
                                    }}
                                >
                                    <div className="d-flex justify-content-end">
                                        <button
                                            onClick={() => navigate(`/users/${user.username}`)}
                                            className="btn"
                                            style={{
                                                fontWeight: "500",
                                                color: "rgba(0, 103, 91, 1)",
                                            }}
                                        >
                                            View Profile
                                        </button>
                                    </div>
                                    <div className="card mb-4 p-4 shadow-sm">
                                        <div className="container mt-2 mb-3">
                                            <div className="row align-items-center text-center text-md-start gx-2">
                                                <div className="col-12 col-md-2 mb-3 mb-md-0 d-flex justify-content-center justify-content-md-start">
                                                    <div
                                                        className="profile-circle"
                                                        style={{
                                                            position: "relative",
                                                            overflow: "hidden",
                                                            width: "100px",
                                                            height: "100px",
                                                            borderRadius: "50%",
                                                        }}
                                                    >
                                                        {preview ? (
                                                            <img
                                                                src={preview}
                                                                alt="Profile"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit: "cover",
                                                                }}
                                                            />
                                                        ) : profileUrl ? (
                                                            <img
                                                                src={profileUrl}
                                                                alt="Profile"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit: "cover",
                                                                }}
                                                            />
                                                        ) : (
                                                            <span style={{ fontSize: "28px", fontWeight: "bold" }}>
                                                                {user ? getInitials(user.realname) : ""}
                                                            </span>
                                                        )}

                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                bottom: "5px",
                                                                right: "5px",
                                                                width: "28px",
                                                                height: "28px",
                                                                borderRadius: "50%",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                zIndex: 2,
                                                                pointerEvents: "none",
                                                            }}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faEdit}
                                                                style={{ fontSize: "14px", color: "black" }}
                                                            />
                                                        </div>

                                                        {/* FILE INPUT */}
                                                        <input
                                                            type="file"
                                                            accept="image/png, image/jpg, image/jpeg"
                                                            onChange={handleImageChange}

                                                            style={{
                                                                position: "absolute",
                                                                top: 0,
                                                                left: 0,
                                                                width: "100%",
                                                                height: "100%",
                                                                opacity: 0,
                                                                cursor: "pointer",
                                                                zIndex: 3,
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-9">
                                                    <h4 className="mt-3 mt-md-0 mb-1 name">{user.realname}</h4>
                                                    <p className="text-muted mb-0">{user.username}</p>
                                                    <p className="text-muted mb-0">
                                                        {user.email}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row g-3">
                                            <div className="col-md-4">
                                                <Autocomplete
                                                    options={["Male", "Female", "Other"]}
                                                    value={formData.gender || ""}
                                                    onChange={(e, newValue) =>
                                                        handleChange({
                                                            target: { name: "gender", value: newValue || "" },
                                                        })
                                                    }
                                                    fullWidth
                                                    size="small"
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Select Gender"
                                                            name="gender"
                                                            variant="outlined"
                                                            sx={{
                                                                "& .MuiAutocomplete-input": {
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden"
                                                                },
                                                                "& .MuiInputBase-root": {
                                                                    borderRadius: "8px",
                                                                    fontSize: "0.9rem",
                                                                },
                                                                "& .MuiOutlinedInput-input": {
                                                                    padding: "8px 10px",
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />

                                            </div>
                                            <div className="col-md-4">
                                                <DatePicker
                                                    label="Date of Birth"
                                                    value={formData.dob ? dayjs(formData.dob) : null}
                                                    onChange={(newValue) =>
                                                        setFormData({ ...formData, dob: newValue ? newValue.format('YYYY-MM-DD') : '' })
                                                    }
                                                    slotProps={{
                                                        textField: {
                                                            size: 'small',
                                                            fullWidth: true,
                                                            placeholder: 'Select DOB',
                                                        },
                                                    }}
                                                    sx={{
                                                        width: '100%',

                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-4 text-md-end">
                                                <span className="text-secondary">
                                                    Joined: {formatDate(user?.joined_on )}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="mt-4">
                                            <h5 className="about-me-heading">About Me</h5>
                                            <TextField
                                                name="about_me"
                                                placeholder="Add Information about you"
                                                multiline
                                                minRows={3}
                                                fullWidth
                                                value={formData.about_me}
                                                onChange={handleChange}
                                                variant="outlined"
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "8px",
                                                    },
                                                    "& textarea": {
                                                        resize: "none",
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="section-wrapper mb-4">
                                        <h5 className="heading mb-3 text-start">
                                            Educational Information
                                        </h5>
                                        <div className="card p-4 shadow-sm">
                                            <div className="row g-3">
                                                <div className="col-md-4">
                                                    <label className="form-label">Highest Qualification</label>
                                                    <Autocomplete
                                                        options={masterData?.qualifications || []}
                                                        getOptionLabel={(option) => option.name || ""}
                                                        value={
                                                            masterData?.qualifications?.find(
                                                                (q) => Number(q.id) === Number(formData.highest_qualification)
                                                            ) || null
                                                        }
                                                        onChange={(e, newValue) =>
                                                            handleChange({
                                                                target: {
                                                                    name: "highest_qualification",
                                                                    value: newValue ? newValue.id : "",
                                                                },
                                                            })
                                                        }
                                                        fullWidth
                                                        size="small"
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select Qualification"
                                                                variant="outlined"
                                                                sx={{
                                                                    "& .MuiAutocomplete-input": {
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        overflow: "hidden"
                                                                    },
                                                                    "& .MuiInputBase-root": {
                                                                        borderRadius: "8px",
                                                                        fontSize: "0.9rem",
                                                                    },
                                                                    "& .MuiOutlinedInput-input": {
                                                                        padding: "8px 10px",
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />

                                                </div>

                                                <div className="col-md-4">
                                                    <label className="form-label">Institute Name</label>
                                                    <Autocomplete
                                                        options={masterData?.institute_name || []}
                                                        getOptionLabel={(option) => option.name || ""}
                                                        value={
                                                            masterData?.institute_name?.find(
                                                                (inst) => Number(inst.org_id) === Number(formData.institution_id)
                                                            ) || null
                                                        }
                                                        onChange={(e, newValue) =>
                                                            handleChange({
                                                                target: {
                                                                    name: "institution_id",
                                                                    value: newValue ? Number(newValue.org_id) : "",
                                                                },
                                                            })
                                                        }
                                                        fullWidth
                                                        size="small"
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select Institute"
                                                                variant="outlined"
                                                                sx={{
                                                                    "& .MuiAutocomplete-input": {
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        overflow: "hidden"
                                                                    },
                                                                    "& .MuiInputBase-root": {
                                                                        borderRadius: "8px",
                                                                        fontSize: "0.9rem",
                                                                    },
                                                                    "& .MuiOutlinedInput-input": {
                                                                        padding: "8px 10px",
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label">Year Of Passing</label>
                                                    <Autocomplete
                                                        options={Array.from({ length: 36 }, (_, i) => 1991 + i)}
                                                        value={formData.year_of_passing || ""}
                                                        onChange={(e, newValue) =>
                                                            handleChange({
                                                                target: {
                                                                    name: "year_of_passing",
                                                                    value: newValue || "",
                                                                },
                                                            })
                                                        }
                                                        fullWidth
                                                        size="small"

                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select Year"
                                                                variant="outlined"
                                                                sx={{
                                                                    "& .MuiAutocomplete-input": {
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        overflow: "hidden",
                                                                    },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        borderRadius: "8px",
                                                                        fontSize: "0.9rem",
                                                                        paddingRight: "30px !important",
                                                                    },
                                                                    "& .MuiOutlinedInput-input": {
                                                                        padding: "8px 10px",
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="section-wrapper">
                                        <h5 className="heading mb-3 text-start">
                                            Professional & Organizational Information
                                        </h5>
                                        <div className="card mb-4 p-4 shadow-sm rounded-4">
                                            <div className="row g-3">
                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">Employment Type</label>
                                                    <Autocomplete
                                                        options={masterData?.employement_type || []}
                                                        getOptionLabel={(option) => option.name || ""}
                                                        value={
                                                            masterData?.employement_type?.find(
                                                                (emp) =>
                                                                    (emp.name) === (formData.employment_type || "")
                                                            ) || null
                                                        }
                                                        onChange={(event, newValue) => handleEmploymentTypeChange(newValue)}

                                                        fullWidth
                                                        size="small"

                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select Employment"
                                                                variant="outlined"
                                                                sx={{
                                                                    "& .MuiAutocomplete-input": {
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        overflow: "hidden",
                                                                    },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        borderRadius: "8px",
                                                                        fontSize: "0.9rem",
                                                                        paddingRight: "30px !important",
                                                                    },
                                                                    "& .MuiOutlinedInput-input": {
                                                                        padding: "8px 10px",
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />

                                                </div>
                                                <div className="col-md-4">
                                                    {formData.employment_type === "Private" ? (
                                                        <>
                                                            <label className="form-label fw-semibold">Government Association</label>

                                                            <TextField
                                                                name="govt_association"
                                                                value={formData.govt_association}
                                                                onChange={handleChange}
                                                                fullWidth
                                                                size="small"
                                                                variant="outlined"
                                                                placeholder="Enter Ministry"
                                                                sx={{
                                                                    "& .MuiInputBase-root": {
                                                                        borderRadius: "8px",
                                                                        fontSize: "0.9rem",
                                                                    },
                                                                    "& .MuiOutlinedInput-input": {
                                                                        padding: "8px 10px",
                                                                    },
                                                                }}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <label className="form-label fw-semibold">Associated Ministry</label>

                                                            <Autocomplete
                                                                options={masterData?.ministry_list || []}
                                                                getOptionLabel={(option) => option?.name || ""}
                                                                value={
                                                                    masterData?.ministry_list?.find(
                                                                        (m) => Number(m.id) === Number(formData.associated_ministry)
                                                                    ) || null
                                                                }
                                                                onChange={(event, newValue) => {
                                                                    handleChange({
                                                                        target: {
                                                                            name: "associated_ministry",
                                                                            value: newValue ? newValue.id : ""
                                                                        }
                                                                    });
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        placeholder="Select Ministry"
                                                                        size="small"
                                                                        variant="outlined"
                                                                        sx={{
                                                                            "& .MuiAutocomplete-input": {
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden",
                                                                            },
                                                                            "& .MuiOutlinedInput-root": {
                                                                                borderRadius: "8px",
                                                                                fontSize: "0.9rem",
                                                                                paddingRight: "30px !important",
                                                                            },
                                                                            "& .MuiOutlinedInput-input": {
                                                                                padding: "8px 10px",
                                                                            },
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </>

                                                    )}
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">Organization/Department Name</label>
                                                    <div className="row g-2">
                                                        <div
                                                            className={
                                                                Number(formData.organization_department_name) === Number(5000)
                                                                    ? "col-12 col-md-4"
                                                                    : "col-12"
                                                            }
                                                        >
                                                            <Autocomplete
                                                                options={[
                                                                    ...(masterData?.departments_list?.map(item => ({
                                                                        label: item.name,
                                                                        value: item.id
                                                                    })) || []),
                                                                ]}
                                                                getOptionLabel={(option) => option.label || ""}
                                                                value={
                                                                    masterData?.departments_list
                                                                        ?.map(item => ({ label: item.name, value: item.id }))
                                                                        .find(item => String(item.value) === String(formData.organization_department_name)) 
                                                                 
                                                                }
                                                                onChange={(event, newValue) => handleOrganizationChange(newValue)}


                                                                isOptionEqualToValue={(option, value) =>
                                                                    String(option.value) === String(value?.value)
                                                                }                                                                
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        placeholder="Select Organization"
                                                                        fullWidth
                                                                        size="small"
                                                                        variant="outlined"
                                                                        sx={{
                                                                            "& .MuiAutocomplete-input": {
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden",
                                                                            },
                                                                            "& .MuiOutlinedInput-root": {
                                                                                borderRadius: "8px",
                                                                                fontSize: "0.9rem",
                                                                                paddingRight: "30px !important",
                                                                            },
                                                                            "& .MuiOutlinedInput-input": {
                                                                                padding: "8px 10px",
                                                                            },
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </div>

                                                        {Number(formData.organization_department_name) === Number(5000) && (
                                                            <div className="col-12 col-md-8">
                                                                <TextField
                                                                    name="other_organization_department_name"
                                                                    placeholder="Enter Organization"
                                                                    value={formData.other_organization_department_name || ""}
                                                                    onChange={handleChange}
                                                                    fullWidth
                                                                    size="small"
                                                                    variant="outlined"
                                                                    sx={{
                                                                        "& .MuiInputBase-root": {
                                                                            borderRadius: "8px",
                                                                            fontSize: "0.9rem",
                                                                        },
                                                                        "& .MuiOutlinedInput-input": {
                                                                            padding: "8px 10px",
                                                                        },
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                {formData.employment_type === "Private" && (
                                                    <div className="col-md-4">
                                                        <label className="form-label fw-semibold">If Govt Associated</label>

                                                        <Autocomplete
                                                            options={[
                                                                { label: "Contractual", value: "contractual" },
                                                                { label: "Third Party", value: "thirdparty" },
                                                            ]}
                                                            getOptionLabel={(option) => option.label || ""}
                                                            value={
                                                                [
                                                                    { label: "Contractual", value: "contractual" },
                                                                    { label: "Third Party", value: "thirdparty" },
                                                                ].find(item => item.value === formData.payroll_company_nature) || null
                                                            }
                                                            onChange={(event, newValue) => {
                                                                handleChange({
                                                                    target: {
                                                                        name: "payroll_company_nature",
                                                                        value: newValue ? newValue.value : "",
                                                                    },
                                                                });
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    placeholder="Select Association"
                                                                    fullWidth
                                                                    size="small"
                                                                    variant="outlined"
                                                                    sx={{
                                                                        "& .MuiAutocomplete-input": {
                                                                            textOverflow: "ellipsis",
                                                                            whiteSpace: "nowrap",
                                                                            overflow: "hidden",
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            borderRadius: "8px",
                                                                            fontSize: "0.9rem",
                                                                            paddingRight: "30px !important",
                                                                        },
                                                                        "& .MuiOutlinedInput-input": {
                                                                            padding: "8px 10px",
                                                                        },
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </div>

                                                )}

                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">Designation</label>

                                                    {(() => {
                                                        // Generate options from masterData
                                                        const options = masterData?.designations_list?.map((item) => ({
                                                            label: item.name,
                                                            value: item.id,
                                                        })) || [];

                                                        // Ensure backend value matches type
                                                        const selectedValue = options.find(
                                                            (opt) => String(opt.value) === String(formData.designation)
                                                        ) || null;

                                                        return (
                                                            <Autocomplete
                                                                options={options}
                                                                getOptionLabel={(option) => option.label}
                                                                isOptionEqualToValue={(option, value) => option.value === value?.value}
                                                                value={selectedValue} // object from options
                                                                onChange={(event, newValue) => {
                                                                    handleChange({
                                                                        target: {
                                                                            name: "designation",
                                                                            value: newValue ? newValue.value : "",
                                                                        },
                                                                    });
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        placeholder="Select Designation"
                                                                        fullWidth
                                                                        size="small"
                                                                        variant="outlined"
                                                                        sx={{
                                                                            "& .MuiAutocomplete-input": {
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden",
                                                                            },
                                                                            "& .MuiOutlinedInput-root": {
                                                                                borderRadius: "8px",
                                                                                fontSize: "0.9rem",
                                                                                paddingRight: "30px !important",
                                                                            },
                                                                            "& .MuiOutlinedInput-input": {
                                                                                padding: "8px 10px",
                                                                            },
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        );
                                                    })()}
                                                </div>


                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">Work Experience</label>

                                                    <Autocomplete
                                                        options={Array.from({ length: 20 }, (_, i) => {
                                                            const year = i + 1;
                                                            return { label: `${year} Year${year > 1 ? "s" : ""}`, value: year };
                                                        })}
                                                        getOptionLabel={(option) => option.label}
                                                        isOptionEqualToValue={(option, value) => option.value === value?.value}
                                                        value={
                                                            Array.from({ length: 20 }, (_, i) => {
                                                                const year = i + 1;
                                                                return { label: `${year} Year${year > 1 ? "s" : ""}`, value: year };
                                                            }).find((opt) => opt.value === Number(formData.years_experience)) || null
                                                        }
                                                        onChange={(event, newValue) => {
                                                            handleChange({
                                                                target: {
                                                                    name: "years_experience",
                                                                    value: newValue ? newValue.value : "",
                                                                },
                                                            });
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select Experience"
                                                                fullWidth
                                                                size="small"
                                                                variant="outlined"
                                                                sx={{
                                                                    "& .MuiAutocomplete-input": {
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        overflow: "hidden",
                                                                    },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        borderRadius: "8px",
                                                                        fontSize: "0.9rem",
                                                                        paddingRight: "30px !important",
                                                                    },
                                                                    "& .MuiOutlinedInput-input": {
                                                                        padding: "8px 10px",
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>


                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">Current Role</label>

                                                    {(() => {
                                                        // Generate options from masterData.roles
                                                        const options = masterData?.roles?.map((item) => ({
                                                            label: item.name,
                                                            value: item.id,
                                                        })) || [];

                                                        // Match backend value (string or number) with options
                                                        const selectedValue = options.find(
                                                            (opt) => Number(opt.value) === Number(formData.current_role)
                                                        ) || null;

                                                        return (
                                                            <Autocomplete
                                                                options={options}
                                                                getOptionLabel={(option) => option.label}
                                                                isOptionEqualToValue={(option, value) => option.value === value?.value}
                                                                value={selectedValue} // object from options
                                                                onChange={(event, newValue) => {
                                                                    handleChange({
                                                                        target: {
                                                                            name: "current_role",
                                                                            value: newValue ? newValue.value : "",
                                                                        },
                                                                    });
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        placeholder="Select Current Role"
                                                                        fullWidth
                                                                        size="small"
                                                                        variant="outlined"
                                                                        sx={{
                                                                            "& .MuiAutocomplete-input": {
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden",
                                                                            },
                                                                            "& .MuiOutlinedInput-root": {
                                                                                borderRadius: "8px",
                                                                                fontSize: "0.9rem",
                                                                                paddingRight: "30px !important",
                                                                            },
                                                                            "& .MuiOutlinedInput-input": {
                                                                                padding: "8px 10px",
                                                                            },
                                                                        }}

                                                                    />
                                                                )}
                                                            />
                                                        );
                                                    })()}
                                                </div>


                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">State</label>

                                                    {(() => {
                                                        // Generate options from masterData.state
                                                        const options = masterData?.state?.map((item) => ({
                                                            label: item.label || item.name,
                                                            value: item.id,
                                                        })) || [];

                                                        // Match backend value (string or number) with options
                                                        const selectedValue = options.find(
                                                            (opt) => String(opt.value) === String(formData.state_id)
                                                        ) || null;

                                                        return (
                                                            <Autocomplete
                                                                options={options}
                                                                getOptionLabel={(option) => option.label}
                                                                isOptionEqualToValue={(option, value) => option.value === value?.value}
                                                                value={selectedValue} // object from options
                                                                onChange={(event, newValue) => {
                                                                    handleChange({
                                                                        target: {
                                                                            name: "state_id",
                                                                            value: newValue ? newValue.value : "",
                                                                        },
                                                                    });
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        placeholder="Select State"
                                                                        fullWidth
                                                                        size="small"
                                                                        variant="outlined"
                                                                        sx={{
                                                                            "& .MuiAutocomplete-input": {
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden",
                                                                            },
                                                                            "& .MuiOutlinedInput-root": {
                                                                                borderRadius: "8px",
                                                                                fontSize: "0.9rem",
                                                                                paddingRight: "30px !important",
                                                                            },
                                                                            "& .MuiOutlinedInput-input": {
                                                                                padding: "8px 10px",
                                                                            },
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        );
                                                    })()}
                                                </div>

                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">Employee ID</label>
                                                    <TextField
                                                        name="employee_id"
                                                        value={formData.employee_id || ""}
                                                        onChange={handleChange}
                                                        placeholder="Enter Employee ID"
                                                        fullWidth
                                                        size="small"
                                                        variant="outlined"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        sx={{
                                                            "& .MuiInputBase-root": {
                                                                borderRadius: "8px",
                                                                fontSize: "0.9rem",
                                                            },
                                                            "& .MuiOutlinedInput-input": {
                                                                padding: "8px 10px",
                                                            },
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="section-wrapper ">
                                        <h5 className="heading mb-3 text-start">Skills & Interests</h5>
                                        <div className="card p-4 shadow-sm">
                                            <div className="d-flex flex-column align-items-start">
                                                <div className="mb-3 w-100" style={{ maxWidth: "800px" }}>
                                                    <label className="form-label">Programming Languages Known</label>
                                                    <Autocomplete
                                                        multiple
                                                        options={masterData.programming_languages || []}
                                                        getOptionLabel={(option) => option.label || option.name}
                                                        value={(masterData.programming_languages || []).filter((item) =>
                                                            (formData.language_ids || []).map(Number).includes(Number(item.id))
                                                        )}
                                                        onChange={(e, newValue) => {
                                                            setFormData({
                                                                ...formData,
                                                                language_ids: newValue.map((item) => item.id),
                                                            });
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select programming languages"
                                                                variant="outlined"
                                                                size="small"
                                                            />
                                                        )}
                                                        sx={{
                                                            width: "100%",
                                                            "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: "0.9rem" },
                                                            "& .MuiOutlinedInput-input": { padding: "8px 10px" },
                                                        }}
                                                    />


                                                </div>
                                                <div className="w-100" style={{ maxWidth: "800px" }}>
                                                    <label className="form-label">Framework / Technologies</label>
                                                    <Autocomplete
                                                        multiple
                                                        options={masterData.frameworks || []} // all framework options
                                                        getOptionLabel={(option) => option.label || option.name}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                        value={(masterData.frameworks || []).filter((item) =>
                                                            (formData.framework_ids || []).map(Number).includes(Number(item.id))
                                                        )}
                                                        onChange={(event, newValue) => {
                                                            setFormData({
                                                                ...formData,
                                                                framework_ids: newValue.map((item) => item.id), // store only IDs
                                                            });
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select frameworks"
                                                                variant="outlined"
                                                                size="small"
                                                            />
                                                        )}
                                                        sx={{
                                                            width: "100%",
                                                            "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: "0.9rem" },
                                                            "& .MuiOutlinedInput-input": { padding: "8px 10px" },
                                                        }}
                                                    />
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ textAlign: "center" }}>
                                    <button type="submit" className="update-button">
                                        Update Profile
                                    </button>
                                </div>
                            </form>
                        </LocalizationProvider>
                        )}
            </div>
        </main>
    );
}
